import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a55f3788&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a55f3788')) {
      api.createRecord('a55f3788', component.options)
    } else {
      api.reload('a55f3788', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a55f3788&", function () {
      api.rerender('a55f3788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/offershelp.vue"
export default component.exports